import React, { createContext, useContext, useState } from "react";

// Create a Context for carInfo
const BikeInfoContext = createContext();

// Custom hook to use the CarInfo context
export const useBikeInfo = () => useContext(BikeInfoContext);

// Provider component
export const BikeInfoProvider = ({ children }) => {
  const [bikeInfo, setBikeInfo] = useState({
    year: "",
    make: "",
    model: "",
    // version: [],
    // sellItForMe: [],
  });

  return (
    <BikeInfoContext.Provider value={[bikeInfo, setBikeInfo]}>
      {children}
    </BikeInfoContext.Provider>
  );
};
